/**
 * How often a mounted dashboard re-reads the shift counts and the shift list (GOTU-8310).
 *
 * The tab badge (`useGetDashboardJobInfo`) and the list it labels (`useGetDashboardJobs`)
 * are two separate queries, and `useJobList` derives the list's `totalPages` from the
 * counts — so refreshing one without the other leaves them disagreeing on screen, and
 * mis-paginated. Shared here so the two cadences cannot drift apart; the value is the
 * `staleTime` both queries already committed to, not a new number.
 */
export const DASHBOARD_REFRESH_INTERVAL_MS = 60 * 1000;

/**
 * `staleTime` / `gcTime` shared by both dashboard queries. Derived from the poll interval
 * rather than restated as a second `60 * 1000`, so the freshness window and the cadence
 * are a single number. The interval tick fetches regardless of staleness; `staleTime` only
 * gates the *other* triggers (remount, tab return), so a read younger than one poll is reused
 * as-is and an older one is replaced at once. Spread into each `useQuery` — the badge and the
 * list stay on one clock, and there is nowhere left for the four literals to drift.
 */
export const DASHBOARD_QUERY_TIMING = {
  staleTime: DASHBOARD_REFRESH_INTERVAL_MS,
  gcTime: DASHBOARD_REFRESH_INTERVAL_MS,
} as const;
